import { useQuery } from '@tanstack/react-query';

import { NETWORK as BTC_NETWORK } from '@/networks/btc-like/btc';
import { getUtxos } from '@/networks/btc-like/common/transactions/api';
import { ResultUtxo } from '@/networks/btc-like/common/transactions/api';
import { NETWORK as DOGE_NETWORK } from '@/networks/btc-like/doge';
import { NETWORK as LTC_NETWORK } from '@/networks/btc-like/ltc';
import { BtcLikeCurrency } from '@/types';

const NETWORKS = {
  BTC: BTC_NETWORK,
  LTC: LTC_NETWORK,
  DOGE: DOGE_NETWORK,
};

// Create a factory for query options
const getBtcLikeWalletUtxosOptions = (token: BtcLikeCurrency, walletAddress: string | null) => ({
  queryKey: ['BtcLikeWalletUtxos', token, walletAddress] as const,
  queryFn: () => getUtxos(walletAddress!, NETWORKS[token].MempoolApiEndpoint),
  enabled: !!walletAddress,
  refetchInterval: 10000,
});

export const useBtcLikeWalletUtxos = (
  token: BtcLikeCurrency,
  walletAddress: string | null,
  sortFn?: (utxos: ResultUtxo[]) => ResultUtxo[]
) => {
  return useQuery<ResultUtxo[]>({
    ...getBtcLikeWalletUtxosOptions(token, walletAddress),
    select: (data) => sortFn?.(data) ?? data,
  });
};
